import _ from "lodash";
import ApiRequest from "@/helpers/ApiRequest";
import GetHeaders from "@/helpers/GetHeaders";
import {
  SAVE_DOCS_PANEL_STATE,
  SAVE_DOCUMENTS,
  SAVE_DOCUMENTS_COUNT,
  SAVE_DOCUMENTS_DATA,
  SAVE_DOCUMENTS_PAGE,
  SAVE_DOCUMENTS_PER_YEAR,
  SAVE_DOCUMENTS_SELECTION,
  SAVE_EXPORT_DOCUMENTS,
  SAVE_FOCUS_DOC_SELECTION,
  SAVE_FOCUS_DOCUMENTS
} from "@/store/mutation-types";

function getLoadDocumentsBody(
  rootState,
  state,
  payload,
  withSelection = false
) {
  const body = {
    which: rootState.filter.filterFocused ? "filter" : "global",
    page: payload.page,
    page_size: payload.pageSize,
    sort_on: payload.sortOn,
    ascending: payload.sortAsc
  };
  if (payload.search) {
    body.search = payload.search;
  }
  if (payload.ttc) {
    body.selection = payload.ttc;
  }
  if (!withSelection) {
    return body;
  }
  if (state.documentSelection) {
    body.selection = state.documentSelection;
  }
  return body;
}

function mapLoadDocumentsResponse(responseData) {
  const mappedDocuments = [];
  const table = responseData;
  let count = 0;

  _.each(table.author, () => {
    mappedDocuments.push({
      author: table.author[count],
      acronym: table.acronym? table.acronym[count]:"",
      citations: table.citations[count],
      score: table.score? parseFloat(table.score[count]):0,
      coor: table.coor[count],
      familycitations: table.familycitations[count],
      comment: table.comment? parseFloat(table.comment[count]):0,
      totalcost: table.totalcost? table.totalcost[count]:"",
      os: table.os[count],
      pubdate: table.pubdate[count],
      startdate: table.startdate? table.startdate[count]:"",
      year: table.pubdate[count].substr(0, 4),
      title: table.title[count],
      type: table.type[count],
      url: table.url[count],
      webkey: table.webkey[count]
    });
    count++;
  });

  return mappedDocuments;
}

export default {
  actions: {
    loadDocumentSelection: ({ commit }, payload) => {
      commit(SAVE_DOCUMENTS_SELECTION, { selection: payload.selection });
    },
    exportDocuments: async ({ commit }, payload) => {
      return ApiRequest.explorePost(
        "export",
        { docs: payload.docs, model: payload.model },
        GetHeaders.dataHeaders()
      ).then(res => {
        commit(SAVE_EXPORT_DOCUMENTS, { documents: res.data });
      });
    },
    loadDocuments: async ({ commit, state, rootState }, payload) => {
      const body = getLoadDocumentsBody(rootState, state, payload, true);

      return ApiRequest.explorePost(
        "table",
        body,
        GetHeaders.dataHeaders()
      ).then(res => {
        commit(SAVE_DOCUMENTS_PAGE, { page: payload.page });
        commit(SAVE_DOCUMENTS, {
          documents: mapLoadDocumentsResponse(res.data.data)
        });
        commit(SAVE_DOCUMENTS_COUNT, {
          documents_count: res.data.meta.count
        });
        commit(SAVE_EXPORT_DOCUMENTS, { documents: [] });
      });
    },
    loadFocusDocuments: async ({ commit, rootState, state }, payload) => {
      const body = getLoadDocumentsBody(rootState, state, payload);

      if (state.focusDocSelection) {
        body.selection = state.focusDocSelection;
      }

      return ApiRequest.explorePost(
        "table",
        body,
        GetHeaders.dataHeaders()
      ).then(res => {
        commit(SAVE_FOCUS_DOCUMENTS, {
          documents: mapLoadDocumentsResponse(res.data.data)
        });
      });
    },
    loadFocusDocSelection: ({ commit }, payload) => {
      commit(SAVE_FOCUS_DOC_SELECTION, { selection: payload.selection });
    },
    loadDocumentsPerYear: async ({ commit, rootState }) => {
      let filter = null;
      if (rootState.filter.filterFocused) {
        if(rootState.filter.filterFocused._id.includes("invalid")){
          filter = null;
        }
        else{
          filter = rootState.filter.filterFocused._id;
        }
      }

      return ApiRequest.explorePost(
        "reverseagg",
        {
          filt: filter,
          hierarchies: ["yr"],
          convert_top: 0
        },
        GetHeaders.dataHeaders()
      ).then(res => {
        if (res.data.yr) {
          let documentsPerYear = res.data.yr.map(node => {
            return {
              _id: node[0]._id,
              year: node[0].name,
              amount: node[1]
            };
          });
          commit(SAVE_DOCUMENTS_PER_YEAR, {
            documents_per_year: documentsPerYear
          });
        } else {
          console.error("Incorrect data in reverseagg response");
        }
      });
    },
    loadSimilarDocuments: async (_, payload) => {
      let url = "similar?&top=" + 10;

      if (payload.search) {
        url += "&search=" + payload.search;
      }

      return ApiRequest.explorePost(
        url,
        { docs: payload.docs },
        GetHeaders.dataHeaders()
      ).then(res => {
        return res.data;
      });
    },
    loadDocument: async (_, payload) => {
      return ApiRequest.exploreGet(
        "article?doc=" + payload.doc,
        GetHeaders.dataHeaders()
      ).then(res => {
        return res.data;
      });
    },
    saveDocPanelState: ({ commit }, payload) => {
      commit(SAVE_DOCS_PANEL_STATE, payload);
    }
  },
  getters: {},
  mutations: {
    [SAVE_DOCUMENTS_DATA](state, payload) {
      state.documentsData = payload.documents;
    },
    [SAVE_DOCUMENTS](state, payload) {
      state.documents = payload.documents;
    },
    [SAVE_EXPORT_DOCUMENTS](state, payload) {
      state.documentsExport = payload.documents;
    },
    [SAVE_DOCUMENTS_SELECTION](state, payload) {
      state.documentSelection = payload.selection;
    },
    [SAVE_DOCUMENTS_PAGE](state, payload) {
      state.documentsPage = payload.page;
    },
    [SAVE_DOCUMENTS_COUNT](state, payload) {
      state.documentsCount = payload.documents_count;
    },
    [SAVE_DOCUMENTS_PER_YEAR](state, payload) {
      state.documentsPerYear = payload.documents_per_year;
    },
    [SAVE_FOCUS_DOC_SELECTION](state, payload) {
      state.focusDocSelection = payload.selection;
    },
    [SAVE_FOCUS_DOCUMENTS](state, payload) {
      state.focusDocuments = payload.documents;
    },
    [SAVE_DOCS_PANEL_STATE](state, payload) {
      state.documentsPanelState = payload;
    }
  },
  state: {
    document: null,
    documentsPage: 1,
    documents: [],
    documentsExport: [],
    documentsCount: null,
    documentsData: [],
    documentSelection: [],
    documentsPerYear: [],
    focusDocuments: [],
    focusDocSelection: [],
    documentsPanelState: "default"
  }
};
